
import GoodsListPage from '@/components/GoodsListPage'
import pzBadge from '@/components/pzBadge'
import { mapGetters } from 'vuex'
import { orderStatusBySeller } from '@/enum/localEnum'
import { filterDirtyHTML } from '@/utils/filter-dirty-html'
import OrderBoxTabTitle from './OrderBoxTabTitle.vue'
import PZTabs from '@/components/PZTabs'
import PZCategory2 from '@/components/PZTabs/Category2.vue'
import Copy from '@/components/PZIcons/Copy'
import { copyToClip } from '~/utils/index'
import OrderBoxStatus from './OrderBoxStatus.vue'
import GoodsSimpleMessage from '../CSS/GoodsSimpleMessage.vue'
import PZButton from '@/components/PZButton'

export default {
	components: {
		GoodsListPage,
		pzBadge,
		OrderBoxTabTitle,
		PZTabs,
		PZCategory2,
		Copy,
		OrderBoxStatus,
		GoodsSimpleMessage,
		PZButton
	},
	props: {
		tabTitle: {
			type: String
		},
		jumpUrl: {
			type: String
		},
		showNavRight: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			goodsCatalogueId: 6,
			keywords: null,
			sellNavIndex: null,
			sellNavList: [],
			showBack: false,
			lists: [],
			loading: true,
			pageInfo: {
				page: 1,
				pageSize: this.jumpUrl ? 5 : 10,
				total: 0
			},
			buyerList: [],
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			parInfo: {}, //创建订单回调信息
			newTabs: [], //用来显示tabs
			categoryList: [], //用来显示商品分类
			selectedCategory: null, //用来显示当前选中的分类

			// 部分退款相关
			partRefundDialog: false,
			currentRefundOrder: null, // 当前退款的订单
			refundForm: {
				refundType: 'RATIO', // RATIO-按金额比例, QUANTITY-按商品数量
				refundAmount: '',
				refundQuantity: 1 // 退款商品数量
			},
			refundLoading: false,
			lastMoney: {
				handAmount: 0,
				commissionFee: 0
			},
			refundError: '', // 退款金额错误提示
			typeIndex: 0 // 类型索引
		}
	},

	computed: {
		...mapGetters({
			goodsTypeCateList: 'game/goodsTypeCateList',
			myGoodsPage: 'myGoodsPage',
			userinfo: 'user/userinfo'
		}),
		// 计算服务费
		serviceFee() {
			if (!this.currentRefundOrder) return '0.00'
			// 假设服务费为订单金额的5%，可以根据实际情况调整
			const totalAmount = parseFloat(this.currentRefundOrder.receivablePaymentAmount || 0)
			const fee = totalAmount * 0.05
			return fee.toFixed(2)
		},
		// 判断按商品数量是否禁用（商品数量为1时禁用）
		isQuantityDisabled() {
			if (!this.currentRefundOrder) return false
			return this.currentRefundOrder.goodsNum === 1
		}
	},
	watch: {
		$route: {
			handler: function (route) {
				this.sellNavIndex = (route.query && route.query.status) || null
			},
			immediate: true
		}
	},
	methods: {
		handleCopyId(id) {
			copyToClip(id, '已复制')
		},
		// 打开部分退款弹窗
		openPartRefundDialog(item) {
			this.currentRefundOrder = item
			const { commissionFee, receivedAmount } = this.currentRefundOrder
			this.lastMoney.commissionFee = 0
			this.lastMoney.handAmount = receivedAmount + commissionFee
			this.refundForm = {
				refundType: 'RATIO',
				refundAmount: '',
				refundQuantity: 1
			}
			this.refundError = '' // 清空错误提示
			this.partRefundDialog = true
			this.calculateRemaining(1)
		},
		// 切换退款方式
		changeRefundType(type) {
			this.refundForm.refundType = type
			this.refundError = '' // 清空错误提示
			// 切换时重置相关字段
			if (type === 'RATIO') {
				this.refundForm.refundAmount = ''
				this.calculateRemaining(1)
			} else if (type === 'QUANTITY') {
				this.refundForm.refundQuantity = 1
				this.$api
					.getHandMoney({
						num: 1,
						orderId: this.currentRefundOrder.orderId,
						type: 2
					})
					.then(res => {
						if (res.success) {
							this.lastMoney = res.data
							this.refundError = '' // 清空错误提示
						} else {
							// 显示错误提示
							this.refundError = res.info || '退款金额验证失败'
						}
					})
					.catch(err => {
						this.refundError = '计算失败，请稍后重试'
					})
			}
		},
		// 处理数量变化
		handleQuantityChange(value) {
			// // 根据商品数量自动计算退款金额
			// if (this.currentRefundOrder) {
			// 	const unitPrice = parseFloat(this.currentRefundOrder.transactionPrice || 0)
			// 	this.refundForm.refundAmount = (unitPrice * value).toFixed(2)
			// }
			this.$api
				.getHandMoney({
					num: this.refundForm.refundQuantity,
					orderId: this.currentRefundOrder.orderId,
					type: 2
				})
				.then(res => {
					if (res.success) {
						this.lastMoney = res.data
						this.refundError = '' // 清空错误提示
					} else {
						// 显示错误提示
						this.refundError = res.info || '退款金额验证失败'
					}
				})
				.catch(err => {
					this.refundError = '计算失败，请稍后重试'
				})
		},
		// 计算剩余金额
		calculateRemaining(type) {
			// 如果 type 不是数字（比如来自 input 事件的字符串值），则使用默认值 1
			const apiType = typeof type === 'number' ? type : 1

			console.log(this.currentRefundOrder)
			this.$api
				.getHandMoney({
					amount: Number(this.refundForm.refundAmount),
					orderId: this.currentRefundOrder.orderId,
					type: apiType
				})
				.then(res => {
					if (res.success) {
						this.lastMoney = res.data
						this.refundError = '' // 清空错误提示
					} else {
						// 显示错误提示
						this.refundError = res.info || '退款金额验证失败'
					}
				})
				.catch(err => {
					this.refundError = '计算失败，请稍后重试'
				})
		},
		// 提交部分退款
		async submitPartRefund() {
			if (!this.refundForm.refundAmount && this.refundForm.refundType === 'RATIO') {
				this.$message.error('请输入退款金额')
				return
			}

			// 如果有错误提示，不允许提交
			if (this.refundError) {
				this.$message.error(this.refundError)
				return
			}

			try {
				// 调用退款接口 - 根据实际API调整
				const res = await this.$api.upOrderRefund({
					orderId: this.currentRefundOrder.orderId,
					type: this.refundForm.refundType === 'RATIO' ? 1 : 2,
					amount: Number(this.refundForm.refundAmount),
					num: Number(this.refundForm.refundQuantity)
				})

				if (res.success) {
					this.$message.success('退款申请提交成功')
					this.partRefundDialog = false
					this.getOrderList()
				} else {
					this.$message.error(res.info || '退款申请失败')
				}
			} finally {
				this.refundLoading = false
			}
		},
		gotoCustomer(item) {
			// 检查是否有群聊ID
			if (!item.groupId) {
				this.$message.error('暂无可用的群聊')
				return
			}

			// 获取订单流转信息
			this.$api
				.getOrderFlow({ orderNo: item.orderNo })
				.then(res => {
					if (res.success) {
						let { orderNo, title, goodsImage, gameName, createTime } = item
						let { name, transactionPrice, orderTypeName, orderStatus } = res.data

						// 设置订单流转数据
						this.$store.dispatch('ry/setOrderFlow', res.data.orderFlow)
						this.$store.dispatch('ry/setOrderGoods', {
							orderNo,
							title,
							goodsImg: goodsImage,
							gameIdName: gameName,
							orderTypeName,
							statusName: orderStatus,
							createTime,
							transactionPrice,
							compensationName: name
						})

						// 显示订单流转面板
						this.$store.commit('ry/SET_ORDER_FLOW_SHOW', true)

						// 打开聊天窗口
						this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)

						// 设置会话筛选为普通消息
						this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)

						// 通过融云SDK获取会话信息
						this.$RongIMLib
							.getConversation({
								conversationType: 3,
								targetId: item.groupId.toString()
							})
							.then(async ({ code, data }) => {
								if (!code && data) {
									// 构造会话数据
									let conversationData = {
										...data,
										orderNo: item.orderNo
									}

									// 获取群信息以获取群名称
									try {
										const groupRes = await this.$api.findGroup({
											action: { groupId: item.groupId }
										})
										if (groupRes.success && groupRes.data) {
											// 将群名称设置到会话数据中
											conversationData = {
												...conversationData,
												name: groupRes.data.name || groupRes.data.groupName || conversationData.name
											}
										}
									} catch (groupErr) {}

									// 通过 EventBus 触发事件，让 IM 组件调用 selectConversation
									this.$nuxt.$emit('im:selectConversation', {
										conversationData
									})
								} else {
									this.$message.error('获取会话信息失败')
								}
							})
							.catch(err => {
								this.$message.error('进入群聊失败，请稍后重试')
							})
					} else {
						this.$message.error(res.info || '获取订单信息失败')
					}
				})
				.catch(err => {
					this.$message.error('进入群聊失败，请稍后重试')
				})
		},
		searchTypeGood(item, index, keyWork, goodsCatalogueId = null) {
			this.typeIndex = index
			this.keywords = ''
			let sendData = ''
			if (index === 0) {
				sendData = null
			}
			if (index === 1) {
				sendData = 'PAY_SUCCESS'
			}
			if (index === 2) {
				sendData = 'COMPLETE'
			}
			if (index === 3) {
				sendData = 'CANCEL'
			}
			this.sellNavIndex = item.key
			let p = {
				action: {
					orderStatus: sendData,
					keyWork,
					queryType: 1,
					goodsCatalogueId
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.userCenterSellerOrder(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.buyerList = data.records
				this.lists = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			})
		},
		tabsChangeInfo(goodsCatalogueId = null) {
			this.keywords = ''
			let sendData = ''
			if (this.typeIndex === 0) {
				sendData = null
			}
			if (this.typeIndex === 1) {
				sendData = 'PAY_SUCCESS'
			}
			if (this.typeIndex === 2) {
				sendData = 'COMPLETE'
			}
			if (this.typeIndex === 3) {
				sendData = 'CANCEL'
			}
			let p = {
				action: {
					orderStatus: sendData,
					keyWork: this.keywords,
					queryType: 1,
					goodsCatalogueId
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.userCenterSellerOrder(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.buyerList = data.records
				this.lists = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			})
		},
		searchBtn() {
			if (!this.keywords) return
			this.loading = true
			this.searchTypeGood(this.newTabs[0], 0, this.keywords)
		},
		getTime(item) {
			let label = null
			let value = ''
			switch (item.status) {
				case orderStatusBySeller.ONESELF_DOWN_STAND:
					label = '下架时间'
					value = item.oneselfDownStandTime
					break
				case orderStatusBySeller.FORCE_DOWN_STAND:
					label = '下架时间'
					value = item.forceDownStandTime
					break
				case orderStatusBySeller.VERIFY_FAIL:
					label = '审核时间'
					value = item.verifyTime
					break
				case orderStatusBySeller.BEAN_SOLD:
					label = '成交时间'
					value = item.transactionTime
					break
				case orderStatusBySeller.ON_STAND:
					label = '上架时间'
					value = item.onStandTime
					break
				// 待审核和交易中
				default:
					label = '创建时间'
					value = item.createTime
					break
			}
			return `${label}：${value}`
		},
		gotoDetails(item) {
			this.$router.push({
				path: '/account/sellGoodsDetails',
				query: {
					orderNo: item.orderNo
					// templateId: item.templateId
				}
			})
		},
		async activeSellNav(item) {
			this.pageInfo.page = 1
			this.sellNavIndex = item.key
			let _page = {
				page: 1,
				pageSize: this.pageInfo.pageSize,
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			this.$router.push({
				path: '/account/sellerList',
				query: {
					status: item.key
				}
			})
			if (item.key == 'CANCEL') {
				this.getOrderList()
			} else {
				this.getSellerCenter()
			}
			this.sellNavList = await this.setMenuDot(this.sellNavList)
		},
		onCategoryChange(category) {
			this.selectedCategory = category.catalogueId
			this.tabsChangeInfo(category.catalogueId)
		},
		// 下一页
		handleCurrentChange(page) {
			this.pageInfo.page = page
			let _page = {
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			if (this.sellNavIndex == 'CANCEL') {
				this.getOrderList()
			}
		},
		// 分页总数
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			let _page = {
				page: 1,
				pageSize: this.pageInfo.pageSize
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			this.getOrderList()
		},
		/**
		 * 设置小红点
		 */
		async setMenuDot(menu) {
			const [order, goods] = await Promise.all([this.$api.getSellerOrderTodo(), this.$api.getSellerGoodsTodo()])
			if (!goods.data) return
			if (!order.data) return
			const { orderTodoTotal, failAuditTotal, publishTotal, toAuditTotal } = {
				...goods.data,
				...order.data
			}
			const subMenuDotTotal = {
				TRADING: orderTodoTotal, // 交易中
				WAIT_VERIFY: toAuditTotal, // 待审核
				VERIFY_FAIL: failAuditTotal, // 审核失败
				WAIT_PUBLISH: publishTotal // 待发布
			}
			return menu.map(item => {
				const updatedItem = { ...item }
				if (['TRADING', 'WAIT_VERIFY', 'VERIFY_FAIL', 'WAIT_PUBLISH'].includes(updatedItem.key)) {
					updatedItem.dot = subMenuDotTotal[updatedItem.key]
				}
				return updatedItem
			})
		},
		// 获取卖家tab页数据
		async getListGoodsStatus() {
			let p = {
				action: {}
			}
			const res = await this.$api.listGoodsStatus(p)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			// 只保留指定的几个状态：全部、交易中、已出售、已取消
			const allowedKeys = [null, 'TRADING', 'BEAN_SOLD']
			this.sellNavList = await this.setMenuDot(res.data.filter(item => allowedKeys.includes(item.key)))
			this.sellNavList.push({
				key: 'CANCEL',
				value: '已取消'
			})
			this.newTabs = this.sellNavList
		},
		// 获取卖家订单列表
		getOrderList() {
			let p = {
				action: {
					orderStatus: this.sellNavIndex
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.userCenterSellerOrder(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.buyerList = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			})
		},
		// 获取卖家商品列表
		async getCategoryList() {
			const res = await this.$api.getGeneralGoodsCateList()
			if (!res.success) return this.$message.error(res.info)
			this.categoryList = res.data
		},
		// 支付违约金
		getPayOrder(item) {
			let data = {
				orderNo: item.orderNo
			}
			this.$api.orderDetails(data).then(res => {
				if (res.success) {
					this.parInfo = {
						...res.data,
						payName: '违约金',
						businessScene: 'SELLER_LIQUIDATED_DAMAGES'
					}
					this.centerPayDialogVisible = true
					this.$nextTick(() => {
						this.$refs['qrPay'].getQrCode(this.parInfo)
					})
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['qrPay'].closeDialogVisible()
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				this.$refs['qrPay'].closeDialogVisible()
				this.getOrderList()
			} else {
				this.centerPayDialogVisible = payStatus
				this.$refs['qrPay'].closeDialogVisible()
			}
		},
		filterVHTML(htmlStr) {
			return filterDirtyHTML(htmlStr)
		}
	},
	mounted() {
		this.getListGoodsStatus()
		this.getCategoryList()
		this.getOrderList()
	},
	created() {
		if (process.client) this.$store.dispatch('game/GoodsTypeCateList')
	}
}
